import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getActionHistories(payload) {
    const params = getParamsFormObject(payload);
    const path = `/intranet-administrators/action-histories${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async exportActionHistories(payload) {
    const params = getParamsFormObject(payload);
    const path = `/intranet-administrators/action-histories/export${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
